<template>
  <div class="sort-tree">
    <div class="sort-tree-item" v-for="(item, parentIndex) in sortTreeData" :key="item.id">
      <div class="sort-tree-item__content">
        <i class="drag-icon" style="cursor: not-allowed"></i>
        <span class="item-label">{{ item[props.label] }}</span>
        <i class="el-icon-close" @click="handleDelete(item, parentIndex)"></i>
      </div>
      <div class="sort-tree-item__child">
        <div class="sort-tree-item" v-for="(child, index) in item[props.children]" :key="child.id">
          <div
            class="sort-tree-item__content"
            draggable
            @dragstart="handleDragstart($event, child, index, false)"
            @drop="handleDrop($event, child, index, parentIndex, item)"
            @dragover.prevent
          >
            <i class="drag-icon"></i>
            <span class="item-label">{{ child[props.label] }}</span>
            <i class="el-icon-close" @click="handleDelete(child, index, item, parentIndex)"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es'

export default {
  name: 'SortTree',
  props: {
    props: Object
  },
  data() {
    return {
      sortTreeData: []
    }
  },
  methods: {
    /**
     * 更新每一项的排序值
     */
    updateItemSortValue() {
      const vm = this
      function loop(source) {
        source.forEach((item, index) => {
          item[vm.props.sort] = index
          item[vm.props.seleted] = 1
          if (item[vm.props.children]) {
            loop(item[vm.props.children])
          }
        })
      }
      loop(this.sortTreeData)
    },
    /**
     * 获取sortTreeData
     */
    getData() {
      this.updateItemSortValue()
      return this.sortTreeData
    },
    /**
     * 设置sortTreeData
     */
    setData(data) {
      this.sortTreeData = data
    },
    /**
     * 拖拽事件
     */
    handleDragstart(event, moveItem, moveIndex, isRoot) {
      event.dataTransfer.setData(
        'Text',
        JSON.stringify({
          isRoot,
          moveItem,
          moveIndex
        })
      )
    },
    /**
     * 放置事件
     */
    handleDrop(event, dropItem, dropIndex, parentIndex, parentItem) {
      const { isRoot, moveItem, moveIndex } = JSON.parse(event.dataTransfer.getData('Text'))
      if (isRoot) {
        if (parentItem) {
          dropItem = parentItem
        }
        if (parentIndex !== undefined) {
          dropIndex = parentIndex
        }
        if (moveItem.id === dropItem.id) return
        // insert
        this.sortTreeData.splice(dropIndex + (moveIndex < dropIndex ? 1 : 0), 0, moveItem)
        // delete
        this.sortTreeData.splice(moveIndex + (moveIndex < dropIndex ? 0 : 1), 1)
      } else {
        if (moveItem.pid !== dropItem.pid) return
        if (moveItem.id === dropItem.id) return
        // insert
        parentItem[this.props.children].splice(dropIndex + (moveIndex < dropIndex ? 1 : 0), 0, moveItem)
        // delete
        parentItem[this.props.children].splice(moveIndex + (moveIndex < dropIndex ? 0 : 1), 1)
        const type = moveIndex < dropIndex ? 'next' : 'prev'
        const cloneParentItem = cloneDeep(parentItem)
        const children = cloneParentItem[this.props.children]
        children.forEach((item, index) => {
          item[this.props.sort] = index
        })
        this.$emit('drop', cloneParentItem, type)
      }
    },
    /**
     * 删除事件
     */
    handleDelete(item, index, parentItem, parentIndex) {
      if (parentItem) {
        const children = parentItem[this.props.children]
        children.splice(index, 1)
        if (children.length === 0) {
          this.sortTreeData.splice(parentIndex, 1)
        }
      } else {
        this.sortTreeData.splice(index, 1)
      }
      this.$emit('delete', item, this.sortTreeData.length === 0)
    }
  }
}
</script>

<style lang="less">
.sort-tree {
  position: relative;
  cursor: default;
  background: #ffffff;
  color: #262626;

  &-item__content {
    display: flex;
    align-items: center;
    position: relative;
    line-height: 28px;
  }

  & &-item__child {
    position: relative;
    .item-label {
      padding-left: 18px;
    }
  }

  &-item__child:before {
    position: absolute;
    top: 5px;
    left: 25px;
    width: 1px;
    height: calc(100% - 13px);
    border-left: 1px solid #f0f0f0;
    content: ' ';
  }

  &__empty-text {
    margin-top: 10px;
    color: #909399;
    font-size: 14px;
  }

  .drag-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    background-image: url('~@/assets/img/icon-drag1.png');
    background-size: 100%;
    vertical-align: middle;
    cursor: move;
  }

  .item-label {
    max-width: 250px;
    display: inline-block;
    padding-left: 4px;
    user-select: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .el-icon-close {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 18px;
    color: #cccccc;
    cursor: pointer;
  }
}
</style>
